import axios from 'axios';
// import qs from 'qs'
import router from '@/router/index';
import store from '@/store/index';
import { ElMessage } from 'element-plus';
import { SpinkitLoading, SpinkitLoadingClose } from '@/components/SpinkitLoading/index.js';
import { removeSharedAuthCookie } from '@/util/shared-auth';
const data = ref({
    type: 'wave_system_error',
    size: 100,
    color: '#2B9EE6',
    msg: '网络错误',
});
const errorFlag = ref(false);
// 增加接口请求超时加载动画
function loading() {
    // 提供 3 个参数
    SpinkitLoading({
        type: data.value.type,
        size: data.value.size,
        color: data.value.color,
    });
    var id = setInterval(() => {
        if (!errorFlag.value) {
            SpinkitLoadingClose();
            clearInterval(id);
        }
    }, 1000);
}

const toHome = () => {
    router.push({
        name: 'lossDataPage',
    });
};
const toLogin = () => {
    router.push({
        name: 'login',
        // 之前是这样的  注释这里  如果后续不正确  注释打开  下方的注释
        // query: {
        //     redirect:
        //         router.currentRoute.value.path !== '/login'
        //             ?'/login'
        //             : undefined,
        // },
        query: {
            redirect:
                router.currentRoute.value.path !== '/login'
                    ? router.currentRoute.value.fullPath
                    : undefined,
        },
    });
};
let isHandlingLoginException = false;

const handleLoginException = (res) => {
    store.commit('user/removeUserData');
    store.commit('user/removeAccountData');
    removeSharedAuthCookie();

    if (!isHandlingLoginException) {
        isHandlingLoginException = true;
        ElMessage.error(res.msg);
        toLogin();
        setTimeout(() => {
            isHandlingLoginException = false;
        }, 1000);
    }
};

// 开发环境直接请求 API 地址，避免 Vite 代理不支持 followRedirects 导致 301 透传
// Vite 2.x 使用 http-proxy（非 http-proxy-middleware），不支持 followRedirects 选项
const defaultBaseURL = import.meta.env.VITE_APP_API_BASEURL;
const aiChatApiBaseURL = (
    window.__APP_CONFIG__?.aiChatApiBaseUrl ||
    __APP_AI_CHAT_API_BASEURL__ ||
    import.meta.env.VITE_APP_AI_CHAT_API_BASEURL ||
    import.meta.env.VITE_APP_API_BASEURL ||
    ''
).replace(/\/$/, '');

const api = axios.create({
    baseURL: defaultBaseURL,
    withCredentials: false, // 直接跨域请求 API（Access-Control-Allow-Origin: *），不支持凭证模式
    timeout: 300000,
    responseType: 'json',
});

const AI_PROXY_PREFIX = '/ai-proxy';
const aiProxyBaseURL = aiChatApiBaseURL;
// 判断登录状态异常的key
const loginExceptionCodes = {
    A0200: 1,
    A0202: 1,
    A0230: 1,
    A0220: 1,
    // 'RC_A0008': 1
};
const reqUrl = ['user/login'];
api.interceptors.request.use((request) => {
    /**
     * 全局拦截请求发送前提交的参数
     * 以下代码为示例，在请求头里带上 token 信息
     */
    // 判断运行环境
    if (import.meta.env.DEV) {
        request.headers['Env'] = import.meta.env.MODE;
    }
    // 登录所需
    if (store.getters['user/isLogin']) {
        request.headers['Token'] = store.state.user.platformToken;
    }
    if (typeof request.url === 'string' && request.url.includes(AI_PROXY_PREFIX)) {
        request.baseURL = aiProxyBaseURL;
        request.url = request.url.replace(/^\/proxy(?=\/ai-proxy)/, '').replace(/^\/ai-proxy/, '');
    }
    return request;
});
api.interceptors.response.use(
    (response) => {
        /**
         * 全局拦截请求发送后返回的数据，如果数据有报错则在这做全局的错误提示
         * 假设返回数据格式为：{ status: 1, error: '', data: '' }
         * 规则是当 status 为 1 时表示请求成功，为 0 时表示接口需要登录或者登录状态失效，需要重新登录
         * 请求出错时 error 会返回错误信息
         */
        errorFlag.value = false;
        let res = response.data;
        if (reqUrl.includes(response.config.url)) {
            if (res.data && res.data.token) {
                store.commit('user/setToken', res.data.token);
            }
        }
        if (loginExceptionCodes[res.code] == 1) {
            handleLoginException(res);
            return Promise.reject(res);
        } else {
            if (res.code == '00000') {
                return Promise.resolve(res);
            } else if (res.code == 'RC_R0008') {
                // 全局拦截数据丢失页面错误码
                toHome();
                return Promise.resolve({ code: 'RC_R0008', msg: '数据不存在', data: {} });
            } else if (res.code == 'RC_R0002') {
                console.log(res);
                return Promise.reject(res);
            } else {
                return Promise.reject(res);
            }
        }
    },
    (error) => {
        if (!errorFlag.value) {
            errorFlag.value = true;
            loading();
        }
        let message = error.message;
        if (message == 'Network Error') {
            message = '网络遇到点问题，请稍后重试！';
        } else if (message.includes('timeout')) {
            message = '接口请求超时';
        } else if (message.includes('Request failed with status code')) {
            message = '接口' + message.substr(message.length - 3) + '异常';
        }
        // return Promise.reject({"code":})
        error = { code: '00000', msg: '调用异常', data: null };
        Promise.reject(error);
    },
);

export default api;
